module.exports = __webpack_public_path__ + "img/instagram.c94aa0e2.svg";